import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { makes } from "@/lib/inventory";

export const MakesMarquee = () => {
  const loop = [...makes, ...makes];
  return (
    <section aria-labelledby="makes-heading" className="overflow-hidden border-b border-line pb-12 pt-14 lg:pb-16 lg:pt-20" data-testid="makes-marquee-section">
      <div className="container-x mb-8 flex items-center justify-between gap-4">
        <p id="makes-heading" className="eyebrow">
          Makes currently in stock
        </p>
        <Link to="/used-cars" className="link-underline text-sm font-semibold text-ink" data-testid="makes-browse-all-link">
          Browse all
        </Link>
      </div>
      <div className="marquee" aria-hidden="true">
        <div className="marquee-track">
          {loop.map((m, i) => (
            <span key={`${m}-${i}`} className="flex items-center">
              <span className={cn("px-6 font-display text-5xl font-extrabold uppercase tracking-tight sm:text-6xl lg:px-9 lg:text-7xl", i % 2 ? "text-outline" : "text-ink")}>
                {m}
              </span>
              <span className="inline-block h-10 w-2.5 -skew-x-[32deg] bg-brand lg:h-14 lg:w-3" />
            </span>
          ))}
        </div>
      </div>
      <ul className="sr-only">
        {makes.map((m) => (
          <li key={m}>{m}</li>
        ))}
      </ul>
    </section>
  );
};
